export default "__VITE_ASSET__CZp$GSe9__"